// noinspection CssUnknownTarget

import { Component, OnInit, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { selectIsLoading } from 'src/app/loading/state/selectors/loading.selector';
import { MatProgressBar } from '@angular/material/progress-bar';
import { AsyncPipe } from '@angular/common';

@Component({
    selector: 'app-page-spinner',
    template: `
      @if (isLoading$ | async) {
        <mat-progress-bar class="w-100" mode="query" />
      }
      `,
    styles: [`
    @use '@angular/material' as mat;
    mat-progress-bar {
        @include mat.progress-bar-overrides((
          track-height: 3px,
          active-indicator-height: 3px,
          track-color: white,
        ));
    }
    :host mat-progress-bar {position: absolute; z-index: 1000 }
    `
    ],
    imports: [MatProgressBar, AsyncPipe]
})
export class PageSpinnerComponent implements OnInit {
    private store = inject(Store);

    isLoading$: Observable<boolean> = of(false);

    ngOnInit(): void {
        this.isLoading$ =  this.store.select(selectIsLoading);
    }
}
